import { render, staticRenderFns } from "./qualityAssessmentSetting.vue?vue&type=template&id=32be23db&scoped=true"
import script from "./qualityAssessmentSetting.vue?vue&type=script&lang=js"
export * from "./qualityAssessmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be23db",
  null
  
)

export default component.exports